module.exports = __webpack_public_path__ + "img/prize_a1.0c5ead20.png";